(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/start-page.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/start-page.js');

'use strict';

const {
  useEffect
} = React;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  StartHeader,
  StartText,
  StartVideo,
  StartPackages,
  StartButtons,
  ButtonChooseNumbers
} = svs.lotto.react.components;
const StartPage = () => {
  useEffect(() => {
    if (isSelfService) {
      svs.numbergames.game.animations.lotto.startFadeInText();
    }
  }, []);
  return React.createElement("div", {
    className: "lotto-start-body f-content"
  }, React.createElement("div", {
    className: "start-top"
  }, React.createElement("div", {
    className: "top-body"
  }, !isSelfService && React.createElement(StartVideo, null), React.createElement(StartHeader, null), React.createElement(StartText, null), React.createElement(ButtonChooseNumbers, null))), React.createElement(StartPackages, null), React.createElement(StartButtons, null));
};
const rootEl = document.getElementById('ngStartPageRegion');
if (rootEl) {
  ReactDOM.render(React.createElement(StartPage, null), rootEl);
}

 })(window);